import gql from 'graphql-tag'

export const listContentTranslationLanguages = gql`
query listContentTranslationLanguages {
	cashAssist {
		listContentTranslationLanguages {
			items {
				id
				locale
			}
		}
	}
}
`
export const createLanguageMutation = gql`
mutation createContentTranslationLanguage($locale: Locale!) {
	cashAssist {
		createContentTranslationLanguage(required: {
			locale: $locale
		}) {
			id
			locale
		}
	}
}
`
// export const updateLanguageMutation = gql`
// mutation updateContentTranslationLanguage($id: ID!, $locale: Locale!) {
// 	cashAssist {
// 		updateContentTranslationLanguage(id: $id, fields: {
// 			locale: $locale
// 		}) {
// 			id
// 			locale
// 		}
// 	}
// }
// `
